import {
  MON_NAME, invoiceRows, missingInvoices, nowYM, plural, rodoChecks, today0, ymAdd, type Data, type Settings,
} from '@biuro/shared';
import type { Me } from './api.ts';
import type { Tab } from './hooks.tsx';

export interface Alert {
  lvl: 'bad' | 'warn' | 'info';
  title: string;
  text: string;
  action?: { label: string; tab: Tab; sub?: string; href?: string };
}

export function alerts(data: Data, st: Settings, me: Me | undefined): Alert[] {
  const out: Alert[] = [];
  const byM: Record<string, string[]> = {};
  for (const x of missingInvoices(data, nowYM())) (byM[x.m] ||= []).push(x.s.name);
  for (const [m, names] of Object.entries(byM).sort()) {
    const late = m < ymAdd(nowYM(), -1);
    out.push({
      lvl: late ? 'bad' : 'warn',
      title: `Brak faktur za ${MON_NAME[+m.slice(5) - 1]} ${m.slice(0, 4)}`,
      text: `${names.join(', ')}. ${late ? 'Termin dla biura już minął: dopisz je jak najszybciej.' : 'Dopisz je przed wysłaniem paczki do biura.'}`,
      action: { label: 'Dodaj fakturę', tab: 'faktury', sub: 'new' },
    });
  }
  const rows = invoiceRows(data);
  const drafts = rows.filter((x) => x.c.draft);
  if (drafts.length) out.push({
    lvl: 'warn', title: `${drafts.length} ${plural(drafts.length, 'faktura czeka', 'faktury czekają', 'faktur czeka')} na uzupełnienie`,
    text: 'PDF-y są już na Dysku. Uzupełnij kwotę, daty i walutę.', action: { label: 'Uzupełnij', tab: 'faktury', sub: 'draft' },
  });
  const noRate = rows.filter((x) => !x.c.draft && x.c.rate == null && x.c.cur);
  if (noRate.length) out.push({
    lvl: 'warn', title: `${noRate.length} ${plural(noRate.length, 'faktura', 'faktury', 'faktur')} bez kursu NBP`,
    text: 'Bez kursu nie policzę kwoty w złotych.', action: { label: 'Pokaż', tab: 'faktury' },
  });
  const unsent = rows.filter((x) => (x.inv.status || 'new') === 'new' && x.c.month && x.c.month < nowYM());
  if (unsent.length) {
    const lateN = unsent.filter((x) => x.c.month < ymAdd(nowYM(), -1)).length;
    out.push({
      lvl: lateN ? 'bad' : 'warn',
      title: `${unsent.length} ${plural(unsent.length, 'faktura czeka', 'faktury czekają', 'faktur czeka')} na wysłanie do biura`,
      text: lateN ? `${lateN} z wcześniejszych miesięcy, po terminie dla biura. Wyślij je w paczce.` : 'Wyślij je w paczce dla biura.',
      action: { label: 'Paczka dla biura', tab: 'miesiac' },
    });
  }
  const ver = Object.values(data.services).filter((s) => s.verify && s.active !== false);
  if (ver.length) out.push({
    lvl: 'info', title: `Uzupełnij dane: ${ver.map((s) => s.name).join(', ')}`,
    text: 'Brakuje m.in. waluty, cyklu albo podmiotu wystawiającego faktury.', action: { label: 'Usługi', tab: 'faktury', sub: 'uslugi' },
  });
  if (me?.isOwner && !(me.google.drive && me.google.calendar)) out.push({
    lvl: 'info', title: 'Połącz Dysk, Kalendarz i Gmail', text: 'Faktury trafią na Twój Dysk, a terminy do Kalendarza Google.',
    action: { label: 'Połącz', tab: 'firma', href: '/auth/connect' },
  });
  if (!data.rodo.main?.wizardDone) {
    out.push({ lvl: 'info', title: 'Utwórz rejestr czynności przetwarzania (RODO)', text: 'Kreator przeprowadzi Cię przez to w kilka minut, z podpowiedziami dla sklepu i usług B2B.',
      action: { label: 'Kreator', tab: 'firma', sub: 'rodo' } });
  } else {
    const checks = rodoChecks({ main: data.rodo.main, activities: Object.entries(data.rodoActivities), processors: data.rodoProcessors }, today0());
    if (checks.length) out.push({ lvl: 'info', title: `Rejestr RODO: ${checks.length} ${plural(checks.length, 'rzecz', 'rzeczy', 'rzeczy')} do sprawdzenia`,
      text: checks[0], action: { label: 'Rejestr', tab: 'firma', sub: 'rodo' } });
  }
  if (!st.nip) out.push({ lvl: 'info', title: 'Dodaj NIP i dane firmy', text: 'Przydadzą się w paczce dla biura i do szybkiego kopiowania.', action: { label: 'Firma', tab: 'firma' } });
  return out;
}
